(() => {
  const priceSelector = [
    '.f-price',
    '.price',
    '[class*="price"]',
    '.money',
    '[class*="money"]',
    '[data-price]',
    '[data-money]',
    '[data-unit-price]',
    '[data-left-to-spend]',
    '.cart-drawer',
    '.cart__footer',
    '.totals'
  ].join(',');

  const stripTrailingZeros = (value) => String(value).replace(/(\d)([.,]00)(?!\d)/g, '$1');

  const cleanElement = (element) => {
    if (!element) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const current = node.nodeValue;
      if (!current || !/[.,]00/.test(current)) return;
      const next = stripTrailingZeros(current);
      if (next !== current) node.nodeValue = next;
    });
  };

  const clean = (root = document) => {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.(priceSelector)) {
      cleanElement(root);
    }
    root.querySelectorAll?.(priceSelector).forEach(cleanElement);
  };

  const wrapMoneyFormatter = () => {
    const currency = window.FoxTheme?.Currency;
    if (!currency || typeof currency.formatMoney !== 'function' || currency.formatMoney.__tmpNoTrailingZeros) return;

    const original = currency.formatMoney.bind(currency);
    const wrapped = (...args) => stripTrailingZeros(original(...args));
    wrapped.__tmpNoTrailingZeros = true;
    currency.formatMoney = wrapped;
  };

  wrapMoneyFormatter();
  clean(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const target = mutation.target.parentElement?.closest?.(priceSelector);
        if (target) cleanElement(target);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          clean(node);
        } else if (node.nodeType === Node.TEXT_NODE) {
          const target = node.parentElement?.closest?.(priceSelector);
          if (target) cleanElement(target);
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
})();
